import { createCustomEnum } from "./customEnum";

const ConnectionPrimaryTypes = createCustomEnum({
	None: {
		value: 0,
		name: "none",
		displayName: "None",
	},
	SIM4G: {
		value: 1,
		name: "SIM4G",
		displayName: "SIM / 4G",
	},
	Wireless: {
		value: 2,
		name: "Wireless",
		displayName: "Wireless",
	},
	Ethernet: {
		value: 3,
		name: "Ethernet",
		displayName: "Ethernet",
	},
	DialUp: {
		value: 4,
		name: "DialUp",
		displayName: "Dial Up",
	},
});

export default ConnectionPrimaryTypes;
